export default __webpack_public_path__ + "static/media/bg-resources.929a76f1.png";